import { render, staticRenderFns } from "./reportStatusTask.vue?vue&type=template&id=6d58638e&scoped=true&"
import script from "./reportStatusTask.vue?vue&type=script&lang=js&"
export * from "./reportStatusTask.vue?vue&type=script&lang=js&"
import style0 from "./reportStatusTask.vue?vue&type=style&index=0&id=6d58638e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d58638e",
  null
  
)

export default component.exports